import type { ReactNode } from "react";

export function BrandRule({ className = "" }: { className?: string }) {
  return (
    <span className={`flex items-center gap-2 ${className}`} aria-hidden="true">
      <span className="h-px w-10 bg-primary/70" />
      <span className="size-1.5 rounded-full bg-primary" />
      <span className="h-px w-10 bg-primary/70" />
    </span>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  lead,
  align = "left",
  tone = "dark",
}: {
  eyebrow: string;
  title: string;
  lead?: string;
  align?: "left" | "center";
  tone?: "dark" | "light";
}) {
  const muted = tone === "dark" ? "text-muted-foreground" : "text-cream-foreground/70";
  return (
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <p className="eyebrow text-primary">{eyebrow}</p>
      <h2 className="mt-3 text-3xl leading-[1.1] font-semibold tracking-tight text-balance-tight md:text-4xl">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-base leading-relaxed ${muted}`}>{lead}</p>}
    </div>
  );
}

export function Section({
  id,
  children,
  tone = "dark",
  className = "",
}: {
  id?: string;
  children: ReactNode;
  tone?: "dark" | "light" | "surface";
  className?: string;
}) {
  const bg =
    tone === "light"
      ? "bg-cream text-cream-foreground"
      : tone === "surface"
        ? "bg-surface text-surface-foreground"
        : "bg-background text-foreground";
  return (
    <section id={id} className={`${bg} scroll-mt-20 ${className}`}>
      <div className="mx-auto max-w-6xl px-5 py-20 md:px-8 md:py-28">{children}</div>
    </section>
  );
}
